/**
 * segment component
 *   @Input() segmentItem: any; // segment Item
 *   @Input() ar: string;       // Aller/retour string
 *   @Input() type: string;     // default / sectorListTitle / journeyList
 */
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { LabelService } from "../service/label/label.service";
import { Yii } from "libraries/interfaces/Yii";
import { DateService } from '../date/date.service';
import { wenji } from "../interfaces/IWenji";
import { ILabels } from "../interfaces/ILabels";
import { LanguageService } from "libraries/service/language/language.service";
import {faArrowRight, IconDefinition, faClock, faStar, faBan, faHeart} from "@fortawesome/free-solid-svg-icons";
import { IFareFamily } from 'libraries/service/resources/booking/interfaces/IGetBookings';
import { IFareFamilyDictionary } from 'libraries/service/resources/airTrip/IGetAirTripQuotes';
import {SizeProp} from "@fortawesome/fontawesome-svg-core";

@Component({
    selector: 'segment',
    templateUrl: './segment.component.html',
    styleUrls: ['./segment.component.scss']
})
export class SegmentComponent implements OnInit, OnChanges {

    @Input()
    public segmentItem: any;
    @Input()
    public luggage: any;
    @Input()
    public luggages: any;
    @Input()
    public segmentItemXId: string;
    @Input()
    public fareFamily: {[key: string]: IFareFamily};
    @Input()
    public fareFamilyDictionary: { [key: string]: IFareFamilyDictionary };
    @Input()
    public type: string;
    @Input()
    public carrier: any;
    @Input()
    public inline: boolean = true;
    @Input()
    public beginDaysDifference: number;
    @Input()
    public showLogo: boolean;
    @Input()
    public displayBan: boolean = false;
    @Input()
    public isFareSentinel: boolean = false;
    public isTooltipVisible: boolean = false;
    public showImage: boolean[] = [];
    public logosUrl: string;
    public segmentData: any;
    public nbStops: number;
    public language: string;
    public segmentFareFamily: IFareFamily;

    public wording: ILabels = {
        jPlus: Yii.t('wui-shared-js', 'J+%placeholder%'),
        jMoins: Yii.t('wui-shared-js', 'J%placeholder%'),
        stop: Yii.t('wui-shared-js', 'escale'),
        stops: Yii.t('wui-shared-js', 'escales'),
        noStop: Yii.t('wui-shared-js', 'direct'),
        fareSentinel: Yii.t('wui-shared-js', 'Fare Sentinel'),
    };

    public dayDiff: string;

    public iconArrowRight: IconDefinition = faArrowRight;
    public iconClock: IconDefinition = faClock;
    public iconStar: IconDefinition = faStar;
    public iconBan: IconDefinition = faBan;
    public iconHeart: IconDefinition = faHeart;

    public iconSize: SizeProp = "2x";

    public alternativesPermission: string = 'iqba.quote.offer.alternatives.use';

    constructor(
        public readonly dateService: DateService,
        public labelService: LabelService,
        public languageService: LanguageService,
    ) { }

    public ngOnInit(): void {
        this.segmentData = this.segmentItem;
        if (this.segmentItem && this.segmentItem.end) {
            this.dayDiff = this.dateService.dayDifference(this.segmentItem.begin, this.segmentItem.end);
        }

        if (this.segmentItem) {
            this.countStops();
        }
        if(this.showLogo){
            this.logosUrl = wenji.locobook.carrierLogos;
        }
    }

    public ngOnChanges(simpleChanges: SimpleChanges): void{
        if (simpleChanges.fareFamily?.currentValue){
            this.initFareFamily();
        }
    }

    /**
     * countStops
     * extract number from segment.stop, store in nbStops
     */
    public countStops(): void {
        this.nbStops = this.segmentItem ? this.segmentItem.stop : 0;
    }

    public toString(num: number): string {
        return String(num);
    }

    public completeLabel(stringToComplete: string, replacements: string): string {
        return this.labelService.completeLabel(stringToComplete, replacements);
    }

    private initFareFamily(): void {
        if(this.fareFamily){
            this.segmentFareFamily = Object
                .values(this.fareFamily)
                .find((fareFamily: IFareFamily): boolean =>
                    fareFamily.segment
                        .some((segmentXId: string): boolean => segmentXId === this.segmentItemXId)
                );
        }
    }
}
